import * as moment from 'moment-timezone';

export const formatTime = (unixTime: number, timeZone?: string) => {
  timeZone = timeZone || moment.tz.guess();
  return moment.unix(unixTime).tz(timeZone).format('MM/DD/YY hh:mma');
};
